module.exports = __webpack_public_path__ + "img/pump-50.b7b30821.svg";